(angular => {
  "use strict";

  angular.module("Auth")
    .controller("Auth.LoginModalCtrl", ["$mdDialog", "$location", "Toast", "Loader", "LoginService", "AuthService", LoginModalCtrl]);

  function LoginModalCtrl($mdDialog, $location, Toast, Loader, LoginService) {
    this.user = {};

    this.login = () => {
      Loader.add(LoginService.doLogin(this.user)).then(() => {
        $location.path("/dashboard");
      }).catch((err) => {
        if (err.status === 404 || err.status === 400) {
          return Toast.show("Dados inválidos", "error");
        }

        Toast.httpHandler(err);
      });
    };

    this.cancel = LoginService.cancel;
  }

})(angular);
